import React, { useState, useEffect } from 'react';
import { Grid, Typography, Box } from '@mui/material';
import EducationRecord, { Education } from './EducationRecord';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import SchoolIcon from '@mui/icons-material/School';

interface EducationSectionProp {
  viewMode?: boolean;
  data: Education[];
}

const EducationSection: React.FC<EducationSectionProp> = ({
  viewMode = false,
  data,
}) => {
  const [educationState, setEducationState] = useState<Education[]>([]);
  const addButtonHandler = () => {
    const newRecord: Education = {
      id: null,
      schoolName: '',
      degree: '',
      gpa: '',
      startDate: null,
      endDate: null,
    };
    setEducationState(state => [...state, newRecord]);
  };
  useEffect(() => {
    setEducationState(data);
  }, [data]);
  const deleteEducationRecord = (idx: number) => {
    setEducationState(state => {
      return [...state.filter((record, i) => i !== idx)];
    });
  };
  const educationRecords = educationState.map((record, i) => {
    return (
      <EducationRecord
        key={i}
        idx={i}
        data={record}
        deleteRecord={deleteEducationRecord}
        viewMode={viewMode}
      />
    );
  });
  // console.log(educationState)
  return (
    <>
      <Grid item xs={12} md={12} sx={{ mt: '60px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '2vh' }}>
          <SchoolIcon sx={{ color: 'var(--ttg-green)', marginRight: '1rem', fontSize: '2.5rem' }} />
          <Typography
            variant="h4"
            sx={{
              color: 'var(--ttg-black)',
              fontFamily: 'inherit',
              textAlign: 'left',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '0.1rem',
              fontSize: { xs: '1.5rem', sm: '2.125rem' },
            }}
          >
            Education
          </Typography>
        </Box>
        {educationRecords}
        {viewMode ? null : (
          <Grid item xs={12} md={12}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={addButtonHandler}
              color="inherit"
              sx={{ marginTop: '3vh' }}
            >
              <AddCircleIcon sx={{ color: 'var(--ttg-black)' }} />
            </IconButton>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default EducationSection;
